import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { GTooltip } from '../g-tooltip'
import { NewGBadgeProps } from './types'

export const GBadge = ({
	text,
	link,
	tooltip,
	className,
	color,
	icon: Icon
}: NewGBadgeProps) => {
	const navigate = useNavigate()

	const textColor = () => {
		if (color === 'bronze') return 'text-amber-800 dark:text-amber-300'
		if (color === 'silver') return 'text-slate-600 dark:text-slate-300'
		if (!color || color === 'neutral') {
			return 'text-t-secondary'
		}
		if (color === 'primary' || color === 'blue') {
			return 'text-t-email-blue'
		}
		if (color === 'green') {
			return 'text-t-badge-success'
		}
		if (color === 'solid-green') {
			return 'text-white font-semibold'
		}
		if (color === 'gray' || color === 'gray-bg') {
			return 'text-t-profile-text'
		}
		if (color === 'purple') {
			return 'text-t-google-tooltip'
		}
		if (color === 'amber') {
			return 'text-amber-500'
		}
		if (color === 'red') {
			return 'text-red-500'
		}
	}

	const bgColor = () => {
		if (color === 'bronze') return 'bg-amber-100 dark:bg-amber-900/30'
		if (color === 'silver') return 'bg-slate-100 dark:bg-slate-700'
		if (!color || color === 'primary') {
			return 'bg-transparent'
		}
		if (color === 'blue') {
			return '!bg-t-blue-400'
		}
		if (color === 'gray-bg') {
			return '!bg-gray-50'
		}
		if (color === 'green') {
			return '!bg-t-badge-active'
		}
		if (color === 'solid-green') {
			return 'bg-green-500'
		}
		if (color === 'purple') {
			return 'bg-bg-plan-fill'
		}
		if (color === 'amber') {
			return '!bg-amber-50'
		}
		if (color === 'red') {
			return 'bg-red-50'
		}
	}

	const borderColor = () => {
		if (color === 'bronze') return 'border-amber-700/30'
		if (color === 'silver') return 'border-slate-300 dark:border-slate-500'
		if (!color || color === 'primary') {
			return 'border-t-badge-border'
		}
		if (color === 'gray') {
			return 'border-t-profile-text'
		}
		if (color === 'amber') {
			return 'border-amber-300'
		}
		if (color === 'green') {
			return 'border-t-badge-active-border'
		}
		if (color === 'solid-green') {
			return 'border-transparent'
		}
		if (color === 'purple') {
			return 'bg-t-checkbox'
		}
		if (color === 'red') {
			return 'border-red-300'
		}
	}

	if (tooltip) {
		return (
			<GTooltip content={tooltip} position="top">
				<div
					className={twMerge(
						'rounded-md text-sm font-inter font-normal py-0.5 px-1.5 w-fit',
						bgColor(),
						textColor(),
						borderColor(),
						link ? 'cursor-pointer' : '',
						`${className}`
					)}
					onClick={() => (link ? navigate(link) : null)}
				>
					{Icon && <Icon />}
					{text}
				</div>
			</GTooltip>
		)
	}

	return (
		<div
			className={twMerge(
				'flex items-center gap-0.5 font-medium border text-sm py-[3px] px-2 w-fit rounded-md',
				bgColor(),
				textColor(),
				borderColor(),
				link ? 'cursor-pointer' : '',
				`${className}`
			)}
			onClick={() => (link ? navigate(link) : null)}
		>
			{Icon && <Icon />}
			{text}
		</div>
	)
}
